import { GetServerSideProps } from "next";
import { ReactElement } from "react";
import { getPageProps } from "@services/initial-calls";
import TermsAndConditions from "@components/shared/legal/termsAndConditions";
import HairStraightenerWrapper from "@components/layouts/hairstraightenerWrapper";

export default function HairStraightenerHome(): ReactElement {
    return (
        <HairStraightenerWrapper>
            <div className="w-full max-w-7xl mx-auto">
                <TermsAndConditions
                    category="Hair Straightener"
                    domain="HairStraightener.claims"
                />
            </div>
        </HairStraightenerWrapper>
    );
}

export const getServerSideProps: GetServerSideProps = async (context) => {
    return await getPageProps(context, "home", {
        pageTitle: "Terms And Conditions",
    });
};
